<template>
  <div class="iv-ring-card">
    <div class="iv-ring-svg-wrap">
      <svg class="iv-ring-svg" width="132" height="132" viewBox="0 0 132 132" aria-hidden="true">
        <circle class="iv-ring-track" cx="66" cy="66" r="52" fill="none" stroke-width="13" />
        <circle
          v-if="view.available && !view.degraded"
          class="iv-ring-arc"
          cx="66"
          cy="66"
          r="52"
          fill="none"
          stroke-width="13"
          stroke-linecap="round"
          :stroke="view.color"
          :stroke-dasharray="view.circumference"
          :stroke-dashoffset="view.dashOffset"
        />
      </svg>
      <div class="iv-ring-center">
        <span class="iv-ring-big" :style="{ color: view.available ? view.color : '#9ca4a2' }">{{ view.big }}</span>
        <span class="iv-ring-small">{{ view.small }}</span>
      </div>
    </div>
    <div class="iv-ring-label">{{ view.label }}</div>
    <div class="iv-ring-sub">{{ view.degraded ? 'Payer did not return a remaining amount' : view.sub }}</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'BenefitRing',
  props: {
    // A ringView() object from constants.js (never raw). Always safe — the
    // helper guarantees no NaN and sensible fallbacks for degraded/absent rings.
    view: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.iv-ring-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #dfe4e3;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(12, 15, 14, 0.05);
}

.iv-ring-svg-wrap {
  position: relative;
  width: 132px;
  height: 132px;
}

.iv-ring-svg {
  transform: rotate(-90deg);
}

.iv-ring-track {
  stroke: #eceff0;
}

.iv-ring-arc {
  transition: stroke-dashoffset 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.iv-ring-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.iv-ring-big {
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

.iv-ring-small {
  font-size: 12px;
  color: #9ca4a2;
  font-variant-numeric: tabular-nums;
  margin-top: 1px;
}

.iv-ring-label {
  font-weight: 700;
  font-size: 14px;
  margin-top: 14px;
  color: #0c0f0e;
}

.iv-ring-sub {
  font-size: 12px;
  color: #717977;
  margin-top: 2px;
}
</style>
